import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject, Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserAccessLog } from 'app/models';
import { ApiUrl } from 'app/constants/ApiUrls';

@Injectable({
  providedIn: 'root'
})
export class UserLogsService implements OnDestroy {
  readonly userLogsUrl = ApiUrl.usersV2;

  private _userLogs: ReplaySubject<UserAccessLog[]> = new ReplaySubject<UserAccessLog[]>();
  public userLogs$: Observable<any> = this._userLogs.asObservable();

  private _error: ReplaySubject<string> = new ReplaySubject<string>();
  public error$: Observable<string> = this._error.asObservable();

  private onDestroy$ = new Subject<void>();

  constructor(
    private _http: HttpClient,
    private _translateService: TranslateService,
  ) { }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  getLogs(userId: string): void {
    this._error.next(null);
    this.loadLogs(userId);
  }

  loadLogs(userId: string): void {
    this._http.get(`${this.userLogsUrl}/${userId}/Logs`)
    .subscribe({
      next: (data) => this._userLogs.next(data as UserAccessLog[]),
      error:  (error) => this._handleUserLogsError(error)
  });
  }

  private _handleUserLogsError(error: HttpErrorResponse): void {
    let errorMsg: string;
    this._translateService.get('ERROR_TRY_LATER')
    .pipe(
      takeUntil(this.onDestroy$)
    ).subscribe(
      value => errorMsg = value
    );
    if (error.error instanceof ErrorEvent) {
      console.error(`[user-logs-service] ERROR: ${error.error.message}`);
    } else {
      console.error(`[user-logs-service] STATUS: ${error.status}, ERROR: ${error.message}`);
    }
    this._error.error(errorMsg);
  }

  clearSubscription(): void {
    this._userLogs.next(null);
  }
}
